'use client'

import { useStorefrontErrorReporting } from '@ventanas95dev/runtime/useStorefrontErrorReporting'
import '../globals.css'

type GlobalErrorProps = {
  error: Error & { digest?: string }
  preview?: boolean
  retry: () => void
}

export default function GlobalError({ error, preview = false, retry }: GlobalErrorProps) {
  useStorefrontErrorReporting(error, { preview, boundary: 'global-error' })

  return (
    <html lang="en">
      <body className="m-0 bg-[#f6f1e7] font-sans text-neutral-900">
        <title>Something went wrong</title>
        <main className="mx-auto box-border flex min-h-screen w-full max-w-[42rem] flex-col items-start justify-center px-6 py-12">
          <p className="m-0 text-xl text-orange-700">!</p>
          <h1 className="my-4 text-[clamp(2.5rem,8vw,4.5rem)]">Something went wrong</h1>
          <p className="m-0 text-lg leading-[1.6]">The storefront could not be displayed.</p>
          <button
            className="mt-8 cursor-pointer border-2 border-neutral-900 bg-orange-700 px-5 py-3 text-white [font:inherit]"
            onClick={() => retry()}
            type="button"
          >
            Try again
          </button>
        </main>
      </body>
    </html>
  )
}
